import { useEffect, useState } from 'react';
import { accessControlService } from '../services/accessControlService';
import { canDo } from '../utils/roleAccess';

/**
 * Whether the current role may perform a catalog action on a section.
 * Re-reads after /my-access and when role access is saved.
 */
export function useCanDo(section, action) {
  const [allowed, setAllowed] = useState(() => canDo(section, action));

  useEffect(() => {
    let cancelled = false;

    const sync = () => {
      if (!cancelled) setAllowed(canDo(section, action));
    };

    sync();
    accessControlService.getMyAccess().then(sync).catch(sync);

    window.addEventListener('menu-access-updated', sync);
    return () => {
      cancelled = true;
      window.removeEventListener('menu-access-updated', sync);
    };
  }, [section, action]);

  return allowed;
}
